<template>
    <div class="grid">
        <Toast/>

        <div class="col-12" style="max-width: 900px;">
            <div class="card">
                <h4>Liquidaciones pendientes</h4>
                <p style="max-width: 720px;">
                    Lo que tu operación fue acumulando y todavía no se ha pagado: las retenciones y
                    el ICE que le debes al SRI, y las propinas que le debes a tus empleados. El
                    sistema los registra solo con cada compra, venta y cobro; aquí los liquidas.
                </p>

                <DataTable :value="liabilities" :loading="loading" class="mt-3">
                    <Column header="Concepto" style="min-width: 240px;">
                        <template #body="slotProps">{{ slotProps.data.label }}</template>
                    </Column>
                    <Column header="A quién" style="width: 130px;">
                        <template #body="slotProps">
                            <Tag :severity="slotProps.data.payee === 'SRI' ? 'warning' : 'info'"
                                 :value="slotProps.data.payee"/>
                        </template>
                    </Column>
                    <Column header="Pendiente" style="width: 140px;">
                        <template #body="slotProps">
                            <span :style="owes(slotProps.data) ? 'font-weight:700;' : 'color:#999;'">
                                ${{ money(slotProps.data.balance) }}
                            </span>
                        </template>
                    </Column>
                    <Column header="" style="width: 130px;">
                        <template #body="slotProps">
                            <Button v-if="owes(slotProps.data)" label="Pagar" icon="pi pi-check"
                                    class="p-button-sm" @click="openPayment(slotProps.data)"/>
                        </template>
                    </Column>
                </DataTable>

                <Message v-if="!loading && !anyPending" severity="success" :closable="false" class="mt-3">
                    No tienes liquidaciones pendientes.
                </Message>
            </div>
        </div>

        <Dialog v-model:visible="dialog" :header="'Pagar: ' + (current.label || '')"
                :modal="true" :style="{width: '440px'}">
            <div style="display:flex; flex-direction:column; gap:1rem;">
                <div>
                    <label style="display:block; font-size:0.85rem; color:#777;">Monto a pagar</label>
                    <InputNumber v-model="amount" mode="decimal" :minFractionDigits="2"
                                 :maxFractionDigits="2" style="width: 100%;"/>
                    <small style="color:#777;">Pendiente: ${{ money(current.balance) }}</small>
                </div>
                <div>
                    <label style="display:block; font-size:0.85rem; color:#777;">Se paga desde</label>
                    <Dropdown v-model="accountId" :options="accounts" optionLabel="name" optionValue="id"
                              placeholder="Elige la cuenta" style="width: 100%;"/>
                </div>
                <Message severity="info" :closable="false">
                    Se registra el pago y <b>se descuenta el dinero de la cuenta que elijas</b>.
                </Message>
            </div>
            <template #footer>
                <Button label="Cancelar" class="p-button-text" @click="dialog = false"/>
                <Button label="Registrar pago" icon="pi pi-check" :loading="working" @click="pay"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import httpRequest from '../../../service/httpRequest';

export default {
    data() {
        return {
            loading: true,
            working: false,
            liabilities: [],
            dialog: false,
            current: {},
            amount: null,
            accountId: null,
        };
    },
    computed: {
        accounts() {
            return this.$store.getters.finantialAccounts || [];
        },
        anyPending() {
            return this.liabilities.some(row => this.owes(row));
        },
    },
    async mounted() {
        await this.load();
    },
    methods: {
        money(value) {
            return parseFloat(value || 0).toFixed(2);
        },
        owes(row) {
            return parseFloat(row.balance || 0) > 0;
        },
        async load() {
            this.loading = true;
            const response = await httpRequest.getAccountingLiabilities();
            this.loading = false;
            if (response.status === 200) {
                this.liabilities = response.data.liabilities;
            } else {
                this.$toast.add({severity: 'error', summary: 'Error',
                                 detail: 'No se pudieron cargar las liquidaciones', life: 4000});
            }
        },
        openPayment(row) {
            this.current = row;
            this.amount = parseFloat(row.balance);
            this.accountId = null;
            this.dialog = true;
        },
        async pay() {
            if (!this.accountId || !this.amount) {
                this.$toast.add({severity: 'warn', summary: 'Faltan datos',
                                 detail: 'Elige la cuenta y el monto', life: 4000});
                return;
            }
            this.working = true;
            const amount = String(this.amount);
            // Cada pasivo tiene su endpoint; el de retenciones acepta ambas en una
            // sola llamada, así que se manda la otra en cero.
            let response;
            if (this.current.key === 'RET_IVA_PAYABLE') {
                response = await httpRequest.payAccountingRetentions(this.accountId, amount, '0');
            } else if (this.current.key === 'RET_RENTA_PAYABLE') {
                response = await httpRequest.payAccountingRetentions(this.accountId, '0', amount);
            } else if (this.current.key === 'ICE_PAYABLE') {
                response = await httpRequest.payAccountingIce(this.accountId, amount);
            } else {
                response = await httpRequest.payAccountingTips(this.accountId, amount);
            }
            this.working = false;
            if (response.status === 200) {
                this.dialog = false;
                this.$toast.add({severity: 'success', summary: 'Pago registrado',
                                 detail: this.current.label, life: 4000});
                await this.load();
            } else {
                this.$toast.add({severity: 'error', summary: 'No se pudo registrar',
                                 detail: response.error || '', life: 5000});
            }
        },
    },
}
</script>
